
import {Routes, Route} from "react-router-dom";
import './App.css';
import Hotspots from './components/hotspots.jsx';
import Homepage from "./components/home.jsx";
import TagPage from "./components/tags.jsx";
import AreaPage from "./components/areas.jsx";
import Layout from "./components/layout.jsx";
import HomeTag from "./components/hometag.jsx";
import AllDataPage from "./components/imagensTotal.jsx"


function App() {
  return (
    <div className='App'>
      <Routes>

        {/* Routes that include the shared menu */}
        <Route element={<Layout/>}>
          <Route path='/' element={<Homepage/>} />
          <Route path='/tags/' element={<HomeTag/>} />
          <Route path='/imagens-total/' element={<AllDataPage/>} />
        </Route>

        <Route path='/tags/:tag' element={<TagPage/>} />
        <Route path='/areas/:area' element={<AreaPage/>} />
        <Route path='/:hotspotId' element={<Hotspots/>} />
        
      </Routes>
    </div>
  );
}



  
export default App;
